// extracted by mini-css-extract-plugin
export default {"loading":"ContentCardGridAutoSliceContainer_loading__xCBX4"};